export default __webpack_public_path__ + "static/media/ascending-deactive.55f298fe.svg";